import React, { useLayoutEffect, useRef } from 'react';
import clsx from 'clsx';
import { useMergedRefs } from '../../hooks/useMergedRefs.ts';
import styles from './ScrollFadeContainer.module.scss';
const SCROLL_EDGE_THRESHOLD = 1;
export const SCROLL_FADE_DIRECTIONS = [
    'vertical',
    'horizontal'
];
export const ScrollFadeContainer = ({ children, direction, fadeStart = true, fadeEnd = true, hideScrollbar = false, maxHeight, ref })=>{
    const containerRef = useRef(null);
    const setRefs = useMergedRefs(containerRef, ref);
    useLayoutEffect(()=>{
        const el = containerRef.current;
        if (!el) return;
        const isHorizontal = direction == 'horizontal';
        let pendingFrame = 0;
        const updateFadeState = ()=>{
            pendingFrame = 0;
            const scrollStart = isHorizontal ? el.scrollLeft : el.scrollTop;
            const scrollSize = isHorizontal ? el.scrollWidth : el.scrollHeight;
            const clientSize = isHorizontal ? el.clientWidth : el.clientHeight;
            const scrolledFromEnd = scrollSize - scrollStart - clientSize;
            el.classList.toggle(styles.fadeStart, fadeStart && scrollStart > SCROLL_EDGE_THRESHOLD);
            el.classList.toggle(styles.fadeEnd, fadeEnd && scrolledFromEnd > SCROLL_EDGE_THRESHOLD);
        };
        const scheduleUpdate = ()=>{
            if (pendingFrame != 0) return;
            pendingFrame = requestAnimationFrame(updateFadeState);
        };
        el.addEventListener('scroll', scheduleUpdate, {
            passive: true
        });
        const resizeObserver = new ResizeObserver(scheduleUpdate);
        resizeObserver.observe(el);
        updateFadeState();
        return ()=>{
            el.removeEventListener('scroll', scheduleUpdate);
            resizeObserver.disconnect();
            if (pendingFrame != 0) cancelAnimationFrame(pendingFrame);
        };
    }, [
        direction,
        fadeStart,
        fadeEnd
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        ref: setRefs,
        className: clsx(styles.scrollFadeContainer, styles[direction], hideScrollbar && styles.hideScrollbar),
        style: {
            maxHeight: maxHeight != undefined ? `${maxHeight}px` : undefined
        }
    }, children);
};
